import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import 'react-datepicker/dist/react-datepicker.css';

export function ProductIncludeConfirmModal({ show, onHide, onConfirm, selectedCount }) {
  const handleConfirmInclude = () => {
    if (typeof onConfirm === 'function') {
      onConfirm();
    }
    onHide();
  };

  return (
    <Modal show={show} onHide={onHide} size="md" centered>
      <Modal.Body>
        <div className="px-3 py-4">
          <div>
            <div className="text-center fs-22 tc-7 mb-2">คุณต้องการเพิ่มสินค้าจำนวน</div>
            <div className="text-center fs-22 tc-7" style={{ color: '#2DC76D' }}>
              {selectedCount || 0} รายการ
            </div>
            <div className="text-center fs-22 tc-7 mt-2">เข้าในรายการที่ไม่ร่วมรายการใช่หรือไม่</div>
          </div>
          <div className="text-center pt-4 mt-3 btn-group-control">
            <Button type="button" className="btn-st-3 mx-3" style={{ width: '100px' }} onClick={handleConfirmInclude}>
              ใช่
            </Button>
            <Button type="button" className="btn-st-6 mx-3" style={{ width: '100px' }} onClick={onHide}>
              ไม่ใช่
            </Button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}
